import request from '@/utils/request'

/**
 * 获取思想及小程序首页banner
 */
export function getAppletHomeBannerList(data) {
  return request({
    url: 'sxjxcx/getAppletHomeBannerList',
    method: 'post',
    params: data
  })
}

/**
 * 添加/修改私享家小程序首页banner
 */
export function editAppletHomeBanner(data) {
  return request({
    url: 'sxjxcx/editAppletHomeBanner',
    method: 'post',
    params: data
  })
}

/**
 * 删除私享家小程序首页banner
 */
export function delAppletHomeBanner(data) {
  return request({
    url: 'sxjxcx/delAppletHomeBanner',
    method: 'post',
    params: data
  })
}
